import axios from 'axios'

import { AxiosHttpClient } from '@webapp/core/libs/AxiosHttpClient'

export const CHANGELOG_API_BASE_URL = 'https://www.procurify.com/wp-json/wp/v2'

/**
 * Marketing's public, unauthenticated WordPress feed. Kept off the app's
 * `ApiClient` on purpose so Procurify client/correlation/CSRF headers are
 * never sent cross-origin (mirrors the `StripeApiClient` precedent), and
 * wrapped in `AxiosHttpClient` for `IHttpClient` parity with other
 * repositories.
 *
 * The host must be present in the CSP `connect-src` allow-list
 * (`docker/frontend-nginx/nginx.conf`) or the browser blocks the request.
 */
export const ChangelogApiClient = new AxiosHttpClient(
  axios.create({ baseURL: CHANGELOG_API_BASE_URL })
)
